/* eslint-disable react/display-name */
import {
  Box,
  IconButton,
  Text,
  useStyleConfig,
  VStack,
} from '@chakra-ui/react';
import { forwardRef } from 'react';
import BEIcon from '@molecules/BEIcon';
import { StepperProps } from './StepperProps';

const Stepper = forwardRef<HTMLInputElement, StepperProps>(
  (
    {
      disabled,
      label,
      description,
      size = 'sm',
      value = 0,
      minValue = 0,
      maxValue = 100,
      typedInputDisabled = false,
      plusDisabled = false,
      stepValue = 1,
      onChange,
    },
    ref
  ) => {
    const onAdd = () => {
      const nextValue = value + stepValue;
      onChange?.(nextValue > maxValue ? maxValue : nextValue);
    };

    const onMinus = () => {
      const nextValue = value - stepValue;
      onChange?.(nextValue < minValue ? minValue : nextValue);
    };

    const onInputChange = (e) => {
      const nextValue = +e.target.value;
      const isValueValid = nextValue >= minValue && nextValue <= maxValue;
      onChange?.(isValueValid ? nextValue : value);
    };

    const styles = useStyleConfig('Stepper', { size });

    return (
      <VStack display="inline-block" spacing="4px" ref={ref}>
        {label && (
          <Text
            fontSize={size === 'sm' ? 'xs' : size === 'md' ? 'sm' : 'md'}
            fontWeight={400}
            color={disabled ? 'neutral.600' : 'black'}
          >
            {label}
          </Text>
        )}
        <Box
          backgroundColor={disabled ? 'neutral.100' : 'white'}
          __css={styles}
        >
          <IconButton
            isDisabled={disabled || value <= minValue}
            size="xs"
            variant="unstyled"
            aria-label="minus"
            icon={<BEIcon name="minus" size={size} color="black" />}
            onClick={onMinus}
          />
          {!typedInputDisabled && (
            <input
              style={{
                textAlign: 'center',
                width: '30px',
                fontSize: '14px',
                fontWeight: 500,
              }}
              disabled={disabled}
              onChange={onInputChange}
              value={value}
            ></input>
          )}
          {typedInputDisabled && (
            <Text color={disabled ? 'neutral.600' : 'black'} fontWeight={500}>
              {value}
            </Text>
          )}
          <IconButton
            isDisabled={disabled || plusDisabled || value >= maxValue}
            size="xs"
            variant="unstyled"
            aria-label="add"
            icon={<BEIcon name="add" size={size} color="black" />}
            onClick={onAdd}
          />
        </Box>
        {size !== 'sm' && description && (
          <Text fontSize={size === 'lg' ? 'sm' : 'xs'}>{description}</Text>
        )}
      </VStack>
    );
  }
);

export default Stepper;
